module.exports = __webpack_public_path__ + "img/bandera_pvasco.3aaeffd5.svg";